<template>
  <table class="log-list">
    <thead>
    <tr class="-head">
      <th v-for="column in columns">
        <skeleton-loader width="200px" height="17px" v-if="loading"/>
        <template v-else>{{ column }}</template>
      </th>
    </tr>
    </thead>
    <tbody v-if="loading">
    <tr v-for="index in 5" :key="index">
      <td><skeleton-loader width="200px" height="17px"/></td>
      <td><skeleton-loader width="200px" height="17px"/></td>
    </tr>
    </tbody>
    <tbody v-else>
    <tr v-for="row in values">
      <td v-for="value in row">{{ value }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import SkeletonLoader from '@/support/components/loader/SkeletonLoader.vue';

export default {
  name: 'LogList',

  props: {
    loading: {
      required: false,
      type: Boolean,
      default: false,
    },

    columns: {
      type: Array,
      required: true,
    },

    values: {
      type: Array,
      requireD: true,
    },
  },

  components: {
    SkeletonLoader,
  },
};
</script>

<style lang="scss" scoped>
.log-list {
  > thead {
    > tr {
      @apply border-t-0;
    }
  }

  > thead,
  > tbody {
    > tr {
      > th,
      > td {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }
    }
  }
}
</style>
